/**
 * @module profile/container/portfolio/entry_details
 */
import { connect } from 'react-redux';
import EntryDetails from 'profile/components/portfolio/mobile_entry_details';
import { resetZoom, getEntryModalState, zoomInEntry,
  zoomOutEntry } from 'profile/ducks/portfolio_entry';
import { getPortfolio, fetchPortfolioEntry } from 'profile/ducks/portfolio';

function mapStateToProps(state) {
  const portfolioState = getPortfolio(state);

  return {
    entryState: getEntryModalState(state),
  };
}

export default connect(mapStateToProps, {
  zoomInEntry,
  zoomOutEntry,
  resetZoom,
})(EntryDetails);



// WEBPACK FOOTER //
// ./profile/containers/portfolio/mobile_entry_details.jsx